import { axiosPost } from '../../axios/axios.config';

export const analyticsData = (data: {start_date:string, end_date:string}) => {
  return axiosPost("/api/v1/getanalytics", {start_date:data.start_date, end_date: data.end_date});
}